pnk-navigation-item {
    /* Component styles go here */
}
